import React from "react"
import { Button } from "react-bootstrap"
import * as Icon from "react-bootstrap-icons"
import { useTranslation } from "react-i18next"

type ExportButtonProps = {
  exporting: boolean
  onClick: () => void
}

export const ExportButton: React.FC<ExportButtonProps> = ({ exporting, onClick }) => {
  const { t } = useTranslation()

  return (
    <Button size="sm" variant="outline-secondary" onClick={onClick} disabled={exporting}>
      <Icon.Download className="me-1" />
      {t("devices_screen.download_csv") || "Download CSV"}
    </Button>
  )
}
